import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Tracks SPA route changes for Google Analytics + Meta (Facebook) Pixel.
 * The initial PageView is fired in index.html when the page loads.
 * This component fires subsequent PageViews when react-router changes routes.
 */
export default function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname + location.search;
    const consent = typeof window !== "undefined" && window.localStorage
      ? window.localStorage.getItem("aa_consent") : null;
    if (consent !== "accepted") return; // No tracking until user consents
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: path,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
    if (typeof window.fbq === "function" && window.__aaPixelOn) {
      window.fbq("track", "PageView");
    }
  }, [location.pathname, location.search]);

  return null;
}
